import React from "react";
import loadable from "@loadable/component";
import { getListingData } from "../../actions/products";

export default {
	component: loadable(() => import(/* webpackChunkName: "homepage" */ "./UserAuth"),{
		fallback: <div>Loading...</div>
	})
};
